module.exports = function(delay, fn) {
    var last, deferTimer;

    return function() {

        var context = this,
            args = arguments,
            now = +new Date;

        if (last && now < last + delay) {

            clearTimeout(deferTimer);

            deferTimer = setTimeout(function() {
                    last = now;
                    fn.apply(context, args);
                },
                delay);

        } else {

            last = now;

            fn.apply(context, args);

        }
    };
};